import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as availability from './availability'
import * as general from './general'
import * as projectEngagements from './project-engagements'
import * as skills from './skills'

/**
 * Body of modal used to edit org chart nodes
 */
@ngCore.Component({
  encapsulation: ngCore.ViewEncapsulation.None,
  imports: [
    ds.tabs.integratedHorizontal.Component,
    ds.tabs.tab.Directive,
    general.Component,
    skills.Component,
    projectEngagements.Component,
    availability.Component,
  ],
  selector: 'atn-summit-org-chart-node-panel-body',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {}
